import ArrowOutwardIcon from '@mui/icons-material/ArrowOutwardRounded';
import GitHubIcon from '@mui/icons-material/GitHub';
import Images from '../utility/Images';
import { PROJECTS_URL } from '../utility/ProjectCatalog';
import { useMagnetic, useTilt } from '../utility/motion';

const SHOWCASE_ICONS = [
    Images.iptvisionIcon,
    Images.memshotIcon,
    Images.topperiaIcon,
    Images.devdexIcon,
    Images.mappinandoIcon,
    Images.appuntoIcon,
    Images.streamwiseLogo,
    Images.sweepIcon,
];

function OpenSource({checked}) {
    const cardRef = useTilt(4);
    const buttonRef = useMagnetic(0.2);

    return (
        <div className="showcase card tilt" ref={cardRef} data-reveal>
            <span className="card__spotlight" aria-hidden="true" />
            <span className="showcase__border" aria-hidden="true" />

            <div className="showcase__copy">
                <span className="mono showcase__kicker">
                    <GitHubIcon className="showcase__kicker-icon" />
                    {checked ? 'Progetti open source' : 'Open-source projects'}
                </span>
                <h3 className="showcase__title">
                    {checked ? 'Dalle idee alle cose che uso.' : 'From ideas to things I use.'}
                </h3>
                <p className="showcase__text">
                    {checked
                        ? 'App, giochi e strumenti per il web e il desktop. Esplora Dueffe Home per scoprire i miei progetti e trovare dettagli e download.'
                        : 'Apps, games and tools for the web and desktop. Explore Dueffe Home to discover my projects, details and downloads.'}
                </p>
                <a ref={buttonRef} href={PROJECTS_URL} className="btn btn--primary magnetic">
                    <span>{checked ? 'Vedi i progetti open source' : 'See open-source projects'}</span>
                    <ArrowOutwardIcon className="btn__icon" />
                </a>
            </div>

            <div className="showcase__visual" aria-hidden="true">
                <div className="icon-cloud">
                    {SHOWCASE_ICONS.map((icon, index) => (
                        <span
                            key={icon}
                            className="icon-cloud__item"
                            style={{ '--i': index, '--n': SHOWCASE_ICONS.length }}
                        >
                            <img src={icon} alt="" loading="lazy" />
                        </span>
                    ))}
                    <span className="icon-cloud__core">DH</span>
                </div>
            </div>
        </div>
    );
}

export default OpenSource;
